"use client";

import React from "react";
import type { ProjectName, UrlProjectName } from "@/app/projects/types";
import { Button } from "@/components/ui/button";
import { Card, CardContent, CardHeader } from "@/components/ui/card";
import { MotionImage, MotionLink } from "@/components/ui/Motion";
import { TypographyH2, TypographyH3 } from "@/components/ui/typography";
import { URLS } from "@/lib/consts";
import { cls } from "@/lib/utils";
import SectionBase from "../section-base";

interface InspirationProject {
  img: string;
  name: ProjectName;
  url: UrlProjectName;
}

const INSPIRATION_PROJECTS: InspirationProject[] = [
  {
    img: "projects/River Ranch/7-web-or-mls-130-01073_rru8vn",
    name: "River Ranch",
    url: "river-ranch",
  },
  {
    img: "projects/Sellers/16-print-QC-08800_hvcp8m",
    name: "Sellers",
    url: "sellers",
  },
];

function GetInspiredSection() {
  return (
    <SectionBase>
      <Card className={cls`w-full flex flex-col justify-center items-center`}>
        <CardHeader className={cls`flex flex- justify-center items-center`}>
          <TypographyH3 className={cls`font-bold text-primary`}>
            INSPIRATION
          </TypographyH3>
          <TypographyH2 className={cls`border-b-0`}>
            Get Inspired by These One-of-a Kind Designs!
          </TypographyH2>
        </CardHeader>

        <CardContent
          className={cls`grid grid-cols-1 md:grid-cols-2 gap-10 w-full md:w-2/3`}
        >
          {INSPIRATION_PROJECTS.map(({ img, name, url }) => (
            <Button
              key={name}
              className={cls`flex flex-col flex-1 h-auto aspect-square overflow-hidden`}
              asChild
            >
              <MotionLink
                className={cls`relative`}
                href={`${URLS.PROJECTS}/${url}`}
              >
                <MotionImage
                  className={cls`rounded-md z-1`}
                  wrapperClassName={cls`absolute inset-0 z-0 rounded-md`}
                  transition={{ duration: 2, stiffness: 300, damping: 20 }}
                  whileHover={{ scale: 1.5 }}
                  src={img}
                  alt={name}
                  fill
                  style={{ objectFit: "cover" }}
                />
                <div
                  className={cls`absolute bg-primary h-min bottom-10 left-0 p-2 px-5`}
                >
                  <TypographyH3>{name}</TypographyH3>
                </div>
              </MotionLink>
            </Button>
          ))}
        </CardContent>
      </Card>
    </SectionBase>
  );
}

export default GetInspiredSection;
